import { MapLatLng } from './map.latlng';

export class MapBounds {
    public swCorner: MapLatLng;
    public neCorner: MapLatLng;

    constructor(swCorner: MapLatLng, neCorner: MapLatLng) {
        this.swCorner = swCorner;
        this.neCorner = neCorner;
    }

    public contains(pos: MapLatLng): boolean {
        return (pos.lat >= this.swCorner.lat && pos.lng >= this.swCorner.lng &&
            pos.lat <= this.neCorner.lat && pos.lng <= this.neCorner.lng);
    }
}
